import React, { useEffect, useState } from "react";
import { Table, Button, Pagination, message } from "antd";
import UserDetail from "../pages/UserDetail";
import CreateBannerModal from "../pages/CreateBannerModal";
import { subItemHooks } from "../hooks";

const SolapiLayout = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [selectedBanner, setSelectedBanner] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);

  // ✅ 선택된 row의 id들을 저장
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const fetchBanners = async (currentPage = 1) => {
    setLoading(true);
    try {
      const response = await subItemHooks.solapiList({ page: currentPage });
      console.log("response : ",response)
      const { data, total_count } = response.data;
      setBanners(data);
      setTotal(total_count);
    } catch (error) {
      console.error("배너 데이터를 가져오는 중 오류가 발생했습니다.", error);
    } finally {
      setLoading(false);
    }
  };
  const handleCreate = async (newProduct) => {
      try {
        const res = await subItemHooks.productCreate({
          brandName: newProduct.brand_name,
          contentId: "",
          productLink: newProduct.product_link,
          productPrice: newProduct.product_price,
          productThumbnail: newProduct.product_thumbnail.split(",")[1],
          productTitle: newProduct.product_title,
        });
        if (res.IsError) {
          throw new Error("create banner error");
        }
        message.success("새 상품이 생성되었습니다.");
        fetchBanners(page);
        setIsCreateModalVisible(false);
      } catch (error) {
        console.error("상품 생성 중 오류가 발생했습니다.", error);
        message.error("상품 생성에 실패했습니다.");
      }
    };

  useEffect(() => {
    fetchBanners(page);
  }, [page]);

  const columns = [
    {
      title: "타입",
      dataIndex: "template_type",
    },
    {
      title: "탬플릿ID",
      dataIndex: "template_id",
    },
    {
      title: "pfid",
      dataIndex: "pfid",
    },
    {
      title: "변수",
      dataIndex: "variables",
      render: (text) => {
        try {
          const parsed = JSON.parse(text);
          return Object.keys(parsed).join(", ");
        } catch (e) {
          return "-";
        }
      },
    },
    {
      title: "메세지",
      dataIndex: "message",
    },
    {
      title: "등록 일자",
      dataIndex: "created_at",
    },
    {
      title: "상세보기",
      render: (record) => (
        <Button
          type="link"
          onClick={() => {
            setSelectedBanner(record);
            setIsModalVisible(true);
          }}
        >
          상세 보기
        </Button>
      ),
    },
  ];

  // ✅ row 선택 기능 설정
  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys) => {
      setSelectedRowKeys(newSelectedRowKeys);
    },
  };

  return (
    <div>
      <div
        style={{
          marginBottom: "20px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        {/* <Button type="primary" onClick={() => setIsCreateModalVisible(true)}>
          배너 생성하기
        </Button> */}
      </div>
      <Table
        columns={columns}
        dataSource={banners}
        rowKey="id"
        pagination={false}
        loading={loading}
        rowSelection={rowSelection} // ✅ 추가
      />
      <Pagination
        current={page}
        total={total}
        pageSize={10}
        onChange={(page) => setPage(page)}
        style={{ marginTop: 20, textAlign: "center" }}
      />
      <UserDetail
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        banner={selectedBanner}
      />
      <CreateBannerModal
        visible={isCreateModalVisible}
        onClose={() => setIsCreateModalVisible(false)}
      />
    </div>
  );
};

export default SolapiLayout;
